export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_MESSAGE_ = 'Load:Message';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';

export const PRICES = {
  mm: 0,
  rubberPrice: 0,
  organicPrice: 0,
};

export const CLASSES = {
  quotationClass: [
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
  ],
};

export const INFORMATION = {
  label: 'Company',
  data: null,
};

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
  informations: [{ ...INFORMATION }],
};

export const MESSAGES = {
  footer: '',
  slogan: '',
  contract: [{ ...INFORMATION }],
  sendMessage: '',
  sendMessageWhats: '',
};

export const FILE = {
  id: null,
  name: null,
  original_name: null,
  url: null,
  uuid: null,
  type: null,
  size: null,
  file_name: null,
};

export const ROW_CLASS = {
  name: '',
  type_id: null,
  file_id: null,
  file: { ...FILE },
};

export const SETTINGS = {
  tax: null,
  logo: null,
  warranty: null,
  timeAlert: null,
  ticketNotification: null,
  quotation: {
    class: [{
      ...ROW_CLASS,
      file: { ...ROW_CLASS.file },
    }],
  },
};

export const OPTION = { id: null, slug: null, name: '' };

export const COLOR_OPTION = {
  id: null,
  name: '',
  color: '',
  time: 0,
  days: 0,
  hours: 0,
  minutes: 0,
};

export const PERMISSION = {
  module_id: null,
  name: null,
  description: null,
  slug: null,
  active: true,
};

export const SLIDER = {
  id: '',
  type_id: null,
  image_id: null,
  order: 0,
  position: 'top',
  image: { ...FILE },
};
